<ng-template #login let-modal>
    <div class="modal-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <img [src]="helper.adminSettings?.logoImage ? helper.imageUrl + helper.adminSettings?.logoImage : helper.DEFAULT_LOGO" alt="">
            <button  type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')" [ngClass]="{ 'hide-close-btn': isProductPage }">
            </button>
        </div>
        <form [formGroup]="loginForm">
            <h3 class="modal-title mt-0 mb-4" id="modal-basic-title">{{"heading-title.login" | translate}}</h3> 
            <div class="form-group">
                <label for="exampleInputEmail1" class="form-label">{{"label-title.email" | translate}}</label>
                <input type="email" class="form-control" formControlName="email" id="exampleInputEmail1"
                    aria-describedby="emailHelp" autocomplete="off" placeholder="{{'label-title.enter-email' | translate}}">
                <div class="required"
                    *ngIf="loginForm.get('email')?.errors?.required && loginForm.get('email')?.touched">* 
                    {{"label-title.email" | translate}} {{"label-title.is-required" | translate}}
                    </div>
                <div class="required" *ngIf="loginForm.get('email')?.errors?.pattern">* {{"label-title.email" | translate}} {{"label-title.is-invalid" | translate}}</div>
            </div>
            <div class="form-group d-flex align-items-center justify-content-between">
                <button type="submit" class="btn_1" (click)="onLogin()">{{"button-title.send-otp" | translate}}</button>
            </div>
            <div>
                <p class="mb-2">{{ "label-title.dont-have-account" | translate}}<a href="javascript:void(0)" class="ms-2 c-pointer" (click)="registerModal()">{{"label-title.create-account" | translate}}</a></p>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #register let-modal>
    <div class="modal-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <img [src]="helper.adminSettings?.logoImage ? helper.imageUrl + helper.adminSettings?.logoImage : helper.DEFAULT_LOGO" alt="">
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')" [ngClass]="{ 'hide-close-btn': isProductPage }">
            </button>
        </div>
        <form [formGroup]="registerForm">
        <h3 class="modal-title mt-0 mb-4" id="modal-basic-title">{{"heading-title.register" | translate}}</h3>
            <div class="form-group mb-3">
                <label for="firstName">{{'label-title.first-name' | translate}}</label>
                <input type="text" class="form-control" formControlName="firstName"
                    placeholder="{{'label-title.first-name' | translate}}">
                <div class="invalid-feedback d-block"
                    *ngIf="registerForm.get('firstName')?.errors?.['required'] && registerForm.get('firstName')?.touched">
                    {{ "label-title.first-name" | translate }} {{ "label-title.is-required" | translate }}.
                </div>
            </div>
            <div class="form-group mb-3">
                <label for="lastName">{{'label-title.last-name' | translate}}</label>
                <input type="text" class="form-control" formControlName="lastName"
                    placeholder="{{'label-title.last-name' | translate}}">
                <div class="invalid-feedback d-block"
                    *ngIf="registerForm.get('lastName')?.errors?.['required'] && registerForm.get('lastName')?.touched">
                    {{ "label-title.last-name" | translate }} {{ "label-title.is-required" | translate }}.</div>
            </div>
            <div class="form-group mb-3">
                <label for="adminphone">{{'label-title.phone' | translate}}</label>
                <input type="number" class="form-control" formControlName="phone"
                    placeholder="{{'label-title.phone' | translate}}" (keypress)="helper.phonenumer($event)"
                    wheel="false">
                <div class="invalid-feedback d-block"
                    *ngIf="registerForm.get('phone')?.errors?.['required'] && registerForm.get('phone')?.touched">
                    {{'validation-title.phone-is-required' | translate}}.</div>
                <div *ngIf="!registerForm.get('phone')?.errors?.['required']">
                    <div class="invalid-feedback d-block"
                        *ngIf="registerForm.get('phone')?.errors?.['minlength'] && registerForm.get('phone')?.touched">
                        {{ "label-title.minimum-characters-allowed" | translate : { _CHARACTER:
                        helper.phoneMinLength } }}
                    </div>
                    <div class="invalid-feedback d-block"
                        *ngIf="registerForm.get('phone')?.errors?.['maxlength'] && registerForm.get('phone')?.touched">
                        {{ "label-title.maximum-characters-allowed" | translate : { _CHARACTER:
                        helper.phoneMaxLength } }}
                    </div>
                </div>
            </div>
            <div class="form-group mb-3">
                <label for="adminemail">{{'label-title.email' | translate}}</label>
                <input type="text" class="form-control" formControlName="email"
                    placeholder="{{'label-title.enter-email' | translate}}">
                <div class="invalid-feedback d-block"
                    *ngIf="registerForm.get('email')?.errors?.['required'] && registerForm.get('email')?.touched">
                    {{'validation-title.email-is-required' | translate}}.</div>
                <div class="invalid-feedback d-block"
                    *ngIf="registerForm.get('email')?.errors?.['pattern'] && registerForm.get('email')?.touched">
                    {{'validation-title.email-is-invalid' | translate}}.</div>
            </div>
            <div class="form-group mb-3">
                <label for="preferredLanguage">{{'label-title.preferred-language' | translate}}</label>
                <ng-select appearance="outline" formControlName="preferredLanguage" [clearable]="false"
                    [searchable]="true" notFoundText="{{'validation-title.no-data-found' | translate}}">
                    <ng-option [value]="type.code" *ngFor="let type of languages">{{ type.label |
                        translate}}</ng-option>
                </ng-select>
                <div class="invalid-feedback d-block"
                    *ngIf="registerForm.get('preferredLanguage')?.errors?.['required'] && registerForm.get('preferredLanguage')?.touched">
                    {{'label-title.preferred-language | translate }} {{'label-title.is-required' |
                    translate}}.</div>
            </div>
            <!-- <div class="form-group form-check d-flex mb-5">
                <div>
                    <input class="form-check-input me-2" formControlName="terms_and_condition" type="checkbox"
                        id="form2Example3c" autocomplete="off" />
                    <label class="form-check-label" for="form2Example3">
                        I agree all statements in <a href="#!">Terms of service</a>
                    </label>
                </div>
                <div class="required" style="left: 0;top: 20px;"
                    *ngIf="registerForm.get('terms_and_condition')?.errors?.required && registerForm.get('terms_and_condition')?.touched">
                    * Terms and Conditions are required
                </div>
                <div class="required" style="left: 0;top: 24px;"
                    *ngIf="registerForm.get('terms_and_condition')?.status == 'VALID' && registerForm.get('terms_and_condition')?.value == false">
                    * Terms and Conditions are required
                </div>
            </div> -->
            <div class="d-flex align-items-center justify-content-between">
                <p class="text-center text-muted mb-0">{{"label-title.already-have-account" | translate}} <a href="javascript:void(0)"
                        (click)="loginModal()">{{"button-title.login-here" | translate}}</a></p>
                <button type="submit" class="btn_1" (click)="onRegister()">{{"button-title.register" | translate}}</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #forgot_password let-modal>
    <div class="modal-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <img [src]="helper.adminSettings?.logoImage ? helper.imageUrl + helper.adminSettings?.logoImage : helper.DEFAULT_LOGO" alt="">
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')" [ngClass]="{ 'hide-close-btn': isProductPage }">
            </button>
        </div>
        <form [formGroup]="forgotForm">
            <h3 class="modal-title mt-0 mb-4" id="modal-basic-title">{{"heading-title.forgot-password" | translate}}</h3>
            <div class="form-group">
            <label for="exampleInputEmail1" class="form-label">{{'label-title.email' | translate}}</label>
                <input type="email" class="form-control" formControlName="email" id="exampleInputEmail1"
                    aria-describedby="emailHelp" autocomplete="off" placeholder="{{'label-title.enter-email' | translate}}">
                <div class="required"
                    *ngIf="forgotForm.get('email')?.errors?.required && forgotForm.get('email')?.touched">* {{"validation-title.email-is-required" | translate}}</div>
                <div class="required" *ngIf="forgotForm.get('email')?.errors?.pattern">* {{"validation-title.email-is-invalid" | translate}}</div>
            </div>
            <div class="form-group">
                <label for="userforgotpassword">{{'label-title.new-password' | translate}}</label>
                <div class="position-relative">
                    <input type="{{showPassword ? 'text' : 'password'}}" class="form-control"
                        formControlName="newPassword" placeholder="{{'label-title.enter-password' | translate}}">
                    <div *ngIf="!showPassword" class="password__show c-pointer" (click)="show_password()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-eye">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                    </div>
                    <div *ngIf="showPassword" class="password__show c-pointer" (click)="show_password()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-eye-off">
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                            </path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                        </svg>
                    </div>
                </div>
                <div class="invalid-feedback d-block"
                    *ngIf="forgotForm.get('newPassword')?.errors?.['required'] && forgotForm.get('newPassword')?.touched">
                    * {{'validation-title.password-is-required' | translate}}.</div>
                <div class="invalid-feedback d-block"
                    *ngIf="forgotForm.get('newPassword')?.errors?.['minlength'] && forgotForm.get('newPassword')?.touched">
                    * {{'validation-title.password-must-be-more-then-6-letters' | translate}}</div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <p class="text-center text-muted mb-0"><a href="javascript:void(0)"
                        (click)="open();forgotModalRef.close();">{{"button-title.login" | translate}}</a></p>
                <button type="submit" class="btn_1" (click)="onForgot()">{{"button-title.submit" | translate}}</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #reset_password let-modal>
    <div class="modal-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <img src="../../../assets/img/default-image/Build_Equity_logo_1.png" alt="">
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            </button>
        </div>
        <form [formGroup]="resetPasswordForm">
            <h3 class="modal-title mt-0 mb-4" id="modal-basic-title">{{'heading-title.reset-password' | translate}}</h3>
            <div class="form-group">
                <label for="exampleInputEmail1" class="form-label">{{'label-title.otp' | translate}}</label>
                <input type="text" class="form-control" formControlName="emailOtp" [maxlength]="6" (keypress)="helper.phone_number_validation($event)" id="exampleInputEmail1"
                    aria-describedby="emailHelp" autocomplete="off">
                <div class="required" *ngIf="resetPasswordForm.get('emailOtp')?.errors?.required && resetPasswordForm.get('emailOtp')?.touched">* {{'validation-title.otp-is-required' | translate}}</div>
                <div class="required" *ngIf="resetPasswordForm.get('emailOtp')?.errors?.minlength">* {{'validation-title.otp-must-be-6-digits' | translate}}</div>
            </div>
            <div class="form-group">
                <label for="exampleInputEmail1" class="form-label">{{'label-title.new-password' | translate}}</label>
                <input type="email" class="form-control" formControlName="password" id="exampleInputEmail1"
                    aria-describedby="emailHelp" autocomplete="off">
                <div class="required" *ngIf="resetPasswordForm.get('password')?.errors?.required && resetPasswordForm.get('password')?.touched">* {{'validation-title.new-password-is-required' | translate}}</div>
                <div class="required" *ngIf="resetPasswordForm.get('password')?.errors?.minlength">* {{'validation-title.password-must-be-more-then-6-letters' | translate}}</div>
            </div>
            <div class="form-group">
                <label for="exampleInputEmail1" class="form-label">{{'label-title.confirm-password' | translate}}</label>
                <input type="email" class="form-control" formControlName="confirmPassword" id="exampleInputEmail1"
                    aria-describedby="emailHelp" autocomplete="off">
                <div class="required" *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.required && resetPasswordForm.get('confirmPassword')?.touched">* {{'validation-title.confirm-password-is-required' | translate}}</div>
                <div class="required" *ngIf="resetPasswordForm.get('confirmPassword')?.errors?.minlength">* {{'validation-title.password-must-be-more-then-6-letters' | translate}}</div>
                <div class="required" *ngIf="passwordsDoNotMatch">
                    {{'validation-title.new-password-and-confirm-password-do-not-match' | translate}}
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-end">
                <button type="submit" class="btn btn_1" (click)="onReset()">{{'button-title.submit' | translate}}</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #phoneCode let-modal>
    <div class="modal-body pb-0">
        <h4 class="modal-title mb-2 mt-0" id="modal-basic-title">{{'heading-title.pick-your-country-code' | translate}}</h4>
        <div class="form-group country-code">
            <input type="email" class="form-control" [(ngModel)]="filterValue" [placeholder]="'label-title.country-code' | translate"
                id="exampleInputEmail1" aria-describedby="emailHelp" autocomplete="off">
        </div>
    </div>
    <div class="country-list">
        <ul>
            <li class="list-item" *ngFor="let country of countryList | countrySearch: filterValue">
                <div class="row c-pointer" (click)="selectedCode(country.code)"
                    [ngClass]="registerForm.value.phoneCode == country.code ? 'active' : ''">
                    <div class="col-3">{{country.code}}</div>
                    <div class="col-9">{{country.name}}</div>
                    <div class="selected" *ngIf="registerForm.value.phoneCode == country.code">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="feather feather-check" _ngcontent-ng-c4224083166="">
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </div>
                </div>
            </li>
            <li *ngIf="(countryList | countrySearch: filterValue)?.length === 0" style="border-bottom: unset;"> 
                <div class="text-center">
                    {{'validation-title.no-country-found' | translate}}
                </div>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template #otp_verification let-modal>
    <div class="modal-body">
        <div class="d-flex align-items-center justify-content-between mb-4">
            <img [src]="helper.adminSettings?.logoImage ? helper.imageUrl + helper.adminSettings?.logoImage : helper.DEFAULT_LOGO" alt="">
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            </button>
        </div>
        <form [formGroup]="otpForm">
            <h3 class="modal-title mt-0 mb-2" id="modal-basic-title">
                {{ otpMode === 'verify' ? ('heading-title.email-verification' | translate) : ('heading-title.login-with-otp' | translate) }}
            </h3>
            <p class="mb-4 text-muted">
                {{ otpMode === 'verify' ? ('paragraph-title.verify-email-with-otp' | translate) : ('paragraph-title.login-with-otp-description' | translate) }}
            </p>
            <div class="form-group mb-3">
                <label class="form-label">{{'label-title.email' | translate}}</label>
                <input type="email" class="form-control" formControlName="email" placeholder="{{'label-title.enter-email' | translate}}">
                <div class="required" *ngIf="otpForm.get('email')?.errors?.['required'] && otpForm.get('email')?.touched">* {{'validation-title.email-is-required' | translate}}</div>
                <div class="required" *ngIf="otpForm.get('email')?.errors?.['pattern']">* {{'validation-title.email-is-invalid' | translate}}</div>
            </div>
            <div class="form-group mb-3">
                <label class="form-label">{{'label-title.otp' | translate}}</label>
                <input type="text" class="form-control" formControlName="otp" maxlength="6" (keypress)="helper.phone_number_validation($event)" placeholder="{{'label-title.enter-otp' | translate}}">
                <div class="required" *ngIf="otpForm.get('otp')?.errors?.['required'] && otpForm.get('otp')?.touched">* {{'validation-title.otp-is-required' | translate}}</div>
                <div class="required" *ngIf="otpForm.get('otp')?.errors?.['minlength'] || otpForm.get('otp')?.errors?.['maxlength']">* {{'validation-title.otp-must-be-6-digits' | translate}}</div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
                <button type="button" class="btn btn-outline-primary" (click)="requestOtp()">
                    {{ otpRequested ? ('button-title.resend-otp' | translate) : ('button-title.send-otp' | translate) }}
                </button>
                <button type="submit" class="btn btn_1" (click)="verifyOtp()">{{'button-title.verify-otp' | translate}}</button>
            </div>
        </form>
    </div>
</ng-template>
